import React from 'react';
import PropTypes from 'prop-types';
import { TrackingUtils } from '../TrackingUtils';

export const withPageContext = (Child) => (
    (props) => (
        <PageContext.Consumer>
            {(context) => <Child pageContext={context} trackEvent={TrackingUtils.fromPageContext(context)} {...props} />}
        </PageContext.Consumer>
    )
);

export const PageContextProp = PropTypes.shape({
    tracking: PropTypes.shape({
        category: PropTypes.string.isRequired,
        page: PropTypes.string.isRequired,
    }).isRequired,
});

export const PageContextPropDefault = {
    tracking: {
        category: TrackingUtils.CATEGORY.HOME,
        page: TrackingUtils.PAGE.HOME,
    },
};

export const PageContext = React.createContext(PageContextPropDefault);
